import React from "react";
import { Link } from "gatsby";
import { useLocation } from "@reach/router";
import * as styles from "./options.module.scss";
import icon1 from "../../../images/icon-repuestos.svg";
import icon2 from "../../../icons/ServicioTecnico/icon-serv-tecnico.svg";
import icon3 from "../../../icons/ServicioTecnico/icon-manuales.svg";

const OptionsComponent = () => {
  const location = useLocation();
  const path = location.pathname;

  let selectedOption = "servicioTecnico";
  if (path.includes("/repuestos")) {
    selectedOption = "repuestos";
  } else if (path.includes("/manuales")) {
    selectedOption = "manuales";
  }

  return (
    <section className={`${styles.SectionContainer} section`}>
      <div className={` ${styles.mainContainer} container`}>
        <div className={styles.TitleContainer}>
          <h2>¿Qué estás buscando?</h2>
          <h5>
            En caso que tu producto se encuentre en garantía (1 año desde la
            fecha de compra) recordá que debés presentar la factura o ticket de
            comprar en el servicio oficial.
          </h5>
        </div>
        <div className={styles.OptionsContainer}>
          <Link
            to="/servicio-tecnico/repuestos/"
            className={`${styles.option} ${selectedOption === "repuestos" ? styles.optionSelected : ""}`}
          >
            <div className={styles.iconContainer}>
              <img src={icon1} alt="Repuestos" />
            </div>
            <p>
              Repuestos<br />y accesorios
            </p>
          </Link>
          
          <Link
            to="/servicio-tecnico/"
            className={`${styles.option} ${selectedOption === "servicioTecnico" ? styles.optionSelected : ""}`}
          >
            <div className={styles.iconContainer}>
              <img src={icon2} alt="Servicio Técnico" />
            </div>
            <p>
              Servicios<br />técnicos
            </p>
          </Link>

          <Link
            to="/servicio-tecnico/manuales/"
            className={`${styles.option} ${selectedOption === "manuales" ? styles.optionSelected : ""}`}
          >
            <div className={styles.iconContainer}>
              <img src={icon3} alt="Manuales" />
            </div>
            <p>
              Descarga<br />tu manual
            </p>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default OptionsComponent;
